<script module lang="ts">
	const stepParams = [
		{ margin: 'mt-[20vh] mb-[70vh]' },
		{},
		{ margin: 'mb-[50vh]' },
		{},
		{ margin: 'mb-[50vh]' }
	];
</script>

<script lang="ts">
	// @ts-expect-error: No types available for svelte-scroller
	import Scroller from '@sveltejs/svelte-scroller';

	import Basemap, { colorExtents } from '$lib/components/fragments/Basemap.svelte';
	import ThreeImagePanel from '$lib/components/fragments/ThreeImagePanel.svelte';
	import Video from '$lib/components/fragments/Video.svelte';
	import Divider from '$lib/components/fragments/Divider.svelte';
	import Section from '$lib/components/fragments/Section.svelte';

	import { fade } from 'svelte/transition';
	import { getCopy } from '$lib/lang/copy.svelte';
	import { formatPercent } from '$lib/utils/format';
	import md from '$lib/utils/md';

	const copy = $derived(getCopy().scrolly);

	let step = $state(0);
</script>

<Section id="introduction" class="relative" padTop={false} padBottom={false}>
	<Scroller top={0} threshold={0.7} bottom={1} query=".step" bind:index={step}>
		{#snippet background()}
			<Basemap {step} />

			{#if step <= 5 && step >= 2}
				<div
					class="bg-blue/90 fixed inset-0 backdrop-blur-sm"
					transition:fade={{ duration: 300 }}
				></div>
			{/if}

			{#if step === 5}
				<ThreeImagePanel images={copy.image_panel_2} />
			{/if}

			{#if step >= 3 && step <= 4}
				<ThreeImagePanel images={copy.image_panel_1} />
			{/if}

			<Video visible={step >= 2 && step < 3} />
		{/snippet}

		{#snippet foreground()}
			<div class="flex flex-col items-center px-4 md:px-8">
				<div class="step relative flex min-h-screen flex-col overflow-hidden md:justify-center">
					<div
						class="flex h-fit flex-col justify-center gap-10 p-4 text-white max-md:mt-20 max-md:items-center max-md:text-center md:max-w-1/2 md:p-10"
					>
						<p class="bg-yellow text-blue over-line-1 w-fit px-3 py-2">
							{copy.hero.overline}
						</p>
						<h1 class="heading-2">{copy.hero.title}</h1>
						<p class="heading-5">{copy.hero.body}</p>
					</div>
				</div>
				<!-- Steps -->
				{#each copy.steps as step, i (i)}
					{@const params = stepParams?.[i]}
					<div
						class={[
							'body-1 step [&_em]:text-yellow max-w-lg bg-black/90 p-6 text-white bg-blend-multiply backdrop-blur-xs [&_em]:font-bold',
							params && params.margin ? params.margin : 'mb-[90vh]'
						]}
					>
						{@html md(step)}
					</div>
				{/each}

				<div class="step mr-auto mb-[80vh] max-w-lg p-4 pt-[30vh] md:mb-[40vh]">
					<div
						class="flex flex-col gap-4 bg-black/90 p-4 text-white bg-blend-multiply backdrop-blur-xs"
					>
						<div class="heading-4 [&_em]:text-yellow">
							{@html md(copy.annotation.hed)}
						</div>

						<Divider />

						<div class="subtitle-2 flex items-center gap-x-2 text-white">
							<span>{formatPercent(colorExtents[0] / 100)}</span>
							<div class="from-red-lightest to-red h-6 w-[150px] bg-gradient-to-r"></div>
							<span>{formatPercent(colorExtents[1] / 100)}</span>
						</div>

						<p class="subtitle-2 font-bold">
							{copy.annotation.dek}
						</p>

						<div class="source text-gray">
							{@html md(copy.annotation.attribution)}
						</div>
					</div>
				</div>
			</div>
		{/snippet}
	</Scroller>
</Section>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	:global(svelte-scroller-foreground) {
		@apply pointer-events-none;
	}

	:global(svelte-scroller-background),
	.step {
		@apply pointer-events-auto;
	}
</style>
